import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as HorizontalOptionsIcon } from '@assets/icons/horizontal-options.svg';

export const Body = styled(Box, {
  display: 'flex',
  alignItems: 'stretch',
  defaultVariants: {
    direction: 'column',
  },
  variants: {
    direction: {
      row: {
        alignItems: 'flex-start',
        flexDirection: 'column',
      },
      column: {
        alignItems: 'stretch',
        flexDirection: 'row',
        width: '100%',
      },
    },
  },
});

export const CardContainer = styled(Box, {
  backgroundColor: '$white',
  border: '1px solid $seafoam400',
  borderRadius: '$4',
  height: '100%',
  padding: 0,
});

export const Content = styled(Box, {
  height: '100%',
  width: '100%',
});

export const Header = styled(Box, {
  alignItems: 'center',
  backgroundColor: '$seafoam800',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '$2 $8',
});

export const Icon = styled(HorizontalOptionsIcon, {});

export const InfoPanel = styled(Box, {
  defaultVariants: {
    direction: 'column',
  },
  variants: {
    direction: {
      column: {
        borderRight: '1px solid $seafoam400',
        display: 'flex',
        flexDirection: 'column',
      },
      row: {
        alignItems: 'center',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
      },
    },
    isReverse: {
      true: {
        borderRight: 'none',
        borderLeft: '1px solid $seafoam700',
      },
    },
  },
});

export const Separator = styled(Box, {
  borderBottom: '1px solid $seafoam700',
});

export const Title = styled(Box, {
  color: '$darkBlue400',
  display: 'flex',
  fontSize: '$md',
  fontWeight: '$bold',
  lineHeight: '$xl',
  width: '100%',
});
